import { profileModalQueryBuilder } from '@/components/modals';

export const profilesQuery = profileModalQueryBuilder
  .filter('_id in $ids')
  .use();
